/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.querySelectorAll('.nav-accordion__header-title').forEach(label=>{
    label.addEventListener('click', function(){
      const target = this.dataset.target;
      document.getElementById(target).checked = true;
    });
  });

  document.querySelectorAll('.section-sidebar__widget .widget__links a').forEach(link=>{
    link.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelectorAll('.section-sidebar__widget .widget__links a').forEach(a=>{
        a.classList.remove('is-selected');
      });
      this.classList.add('is-selected');
      const blockId = this.getAttribute('data-block-id');

      document.querySelectorAll('.section-sidebar__row').forEach(sidebar=>{
        sidebar.classList.remove('is-selected');
      });
      console.log(blockId);

      document.querySelectorAll(`[data-block-id="${blockId}"]`).forEach(sidebar=>{
        sidebar.classList.add('is-selected');
      });
    });
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
